<template>
  <div class="content">
    <div class="flxed">
      <div class="cont" style="margin-bottom: 1px">
        <div class="nav-bd">
          <div class="title">
            <span>{{ seeting.welcome_text }}</span>
            <span>{{ currentDate }}</span>
            <span>{{ currentWeekday }}</span>
          </div>
          <ul class="nav-menu">
            <li>
              <router-link to="/info">会员中心</router-link>
            </li>
            <li>
              <router-link to="/">会员服务</router-link>
            </li>
            <li v-if="!token">
              <router-link class="login" to="/login">登录注册</router-link>
            </li>
            <!-- <li v-else>
                        <router-link class="login" to="/info">{{ userinfo.nickname }}</router-link>
                    </li> -->
            <li v-if="token">
              <a class="login" href="javascript:;" @click="logout">退出登录</a>
            </li>
            <li>
              <router-link to="/InformNotice">通知</router-link>
            </li>
            <li>
              <router-link to="/">广告投放</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="cont">
        <div class="nav-na">
          <div class="titlenavt">
            <img class="img" :src="seeting.logo_image_url" alt="" />
            <div class="name_c">铭顺转店租铺网</div>
          </div>
          <div class="search">
            <img class="simg" src="../../image/search.png" alt="" />
            <input type="text" v-model="searchval" placeholder="请输入关键词进行搜索" />
            <div class="button_s" @click="bindsearch">搜索</div>
          </div>
          <div class="coar">
            <img class="cimg" :src="seeting.qrcode_image_url" alt="" />
            <div class="txt">
              <p>欢迎扫码</p>
              <p>在手机端查看</p>
            </div>
          </div>
          <div class="tell">
            <p>客服热线</p>
            <div class="phone">{{ seeting.service_phone }}</div>
            <p>广告投放：{{ seeting.ad_phone }}</p>
            <p>投诉热线：{{ seeting.complaint_phone }}</p>
          </div>
        </div>
      </div>
      <div class="cont" style="background-color: #d1e5fe">
        <div class="head_n">
          <div class="address" @click="dialogVisible = true">
            <img class="addicon" src="../../image/address.png" alt="" />
            <div class="city_name">{{ citys.value || "苏州" }}</div>
            <img class="xbimg" src="../../image/xb.png" alt="" />
          </div>
          <ul class="nav_a">
            <li v-for="(item, index) of navList" :key="index" :class="{ cur: isActive(item) }">
              <router-link :to="item.path">{{ item.name }}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="cont">
      <div class="headimg">
        <img class="imgs" src="../../image/bj1.png" alt="" />
      </div>
    </div>

    <el-dialog title="选择地区" :visible.sync="dialogVisible" width="30%">
      <!-- <el-select v-model="provinces.value" placeholder="请选择省" style="width:100%;margin-bottom:15px">
                <el-option v-for="item in provinceList" :key="item.id || item.value" :label="item.name || item.label"
                    :value="item.id || item.value">
                </el-option>
            </el-select>
            <el-select v-model="citys.value" placeholder="请选择市" style="width:100%" :disabled="!cityList.length">
                <el-option v-for="item in cityList" :key="item.id || item.value" :label="item.name || item.label"
                    :value="item.id || item.value">
                </el-option>
            </el-select> -->
      <el-autocomplete
        class="inline-input"
        v-model="state1"
        :fetch-suggestions="querySearch"
        placeholder="请输入或选择城市"
        @select="handleSelect"
      ></el-autocomplete>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmCity">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { myrequest } from "@/server/index.js";
export default {
  name: "",
  data() {
    return {
      provinceList: [],
      cityList: [],
      provinces: { value: "", label: "" },
      citys: { id: "", value: "" },
      selectedCity: null,
      dialogVisible: false,
      searchval: "",
      navList: [
        { name: "首页", path: "/home" },
        { name: "商铺转让", path: "/shopTransfer" },
        { name: "商铺出租", path: "/shoprental" },
        { name: "商铺求租", path: "/shopforRent" },
        { name: "成交案例", path: "/completedCase" },
        { name: "招商合作", path: "/businesscoper" },
        { name: "走进铭顺", path: "/corporateCulture" },
        { name: "在线留言", path: "/leave" },
        { name: "会员中心", path: "/info" },
      ],
      token: localStorage.getItem("token") || "",
      userinfo: JSON.parse(localStorage.getItem("userinfo") || "{}"),

      restaurants: [],
      state1: "",
      seeting: {},
    };
  },
  computed: {
    currentDate() {
      const d = new Date();
      return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
    },
    currentWeekday() {
      const weekdays = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
      return weekdays[new Date().getDay()];
    },
  },
  watch: {
    // dialogVisible(val) {
    //     if (val && this.provinceList.length === 0) {
    //         this.getProvinces();
    //     }
    // },
    "provinces.value": {
      handler() {
        if (!this.provinces.value) return;
        this.citys = { value: "", label: "" };
        this.getCities(this.provinces.value);
      },
    },
  },
  created() {
    console.log(localStorage.getItem("cityid"), "000000000000000000000");
    // this.getProvinces();
    this.getAreacitys(); //城市列表
    this.getindexInfo(); //首页数据
    if (localStorage.getItem("cityid")) {
      this.citys.id = localStorage.getItem("cityid");
      this.citys.value = localStorage.getItem("cityname");
    } else {
      this.getLocation();
    }
  },
  methods: {
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    async getindexInfo() {
      let res = await myrequest("indexinfo");
      if (res.code == 1) {
        this.seeting = res.data.setting;
      }
    },
    //获取城市列表
    async getAreacitys() {
      let res = await myrequest("citiesshop");
      if (res.code == 1) {
        this.restaurants = (res.data || []).map((e) => ({
          value: e.name,
          id: e.id,
        }));
      }
    },
    handleSelect(item) {
      this.selectedCity = item;
    },
    async getProvinces() {
      let res = await myrequest("provincecommon");
      if (res.code === 1) {
        this.provinceList = res.data || [];
      }
    },
    async getCities(provinceId) {
      let res = await myrequest("citiesshop", { province_id: provinceId });
      if (res.code === 1) {
        this.cityList = res.data || [];
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    confirmCity() {
      if (this.selectedCity) {
        localStorage.setItem("cityid", this.selectedCity.id);
        localStorage.setItem("viewcityid", this.selectedCity.id);
        localStorage.setItem("cityname", this.selectedCity.value);

        this.citys.id = this.selectedCity.id;
        this.citys.value = this.selectedCity.value;
        this.dialogVisible = false;
        location.reload();
      }
    },
    //获取定位
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            console.log(position.coords, "999999999");
            localStorage.setItem("lat", position.coords.latitude);
            localStorage.setItem("lng", position.coords.longitude);

            this.getLocash(position.coords.latitude, position.coords.longitude);
          },
          (error) => {
            console.error("Error getting location:", error);
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    },
    //根据定位获取城市 resolvecitybylocationpc
    async getLocash(latitude, longitude) {
      let res = await myrequest("resolvecitybylocationpc", {
        lng: longitude, //||120.645135
        lat: latitude, //||31.374217
      });
      if (res.code == 1) {
        // console.log(res,'rrr')
        localStorage.setItem("cityid", res.data.city_id);
      }
    },
    bindsearch() {
      this.$router.push({ name: "Search", query: { value: this.searchval } });
      this.$store.commit("setsearchVal", this.searchval);
    },
    logout() {
      this.$confirm("是否退出登录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          localStorage.removeItem("token");
          localStorage.removeItem("userinfo");
          location.href = "/#/login";
        })
        .catch(function () {});
    },
    isActive(item) {
      return this.$route.path === item.path;
    },
  },
};
</script>
<style scoped lang="less">
.content {
  width: 100%;
  min-width: 1200px;
  // height: 360px;
}
.flxed {
  height: 240px;
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
  left: -8px;
}

.inline-input {
  width: 80%;
}

.cont {
  width: 100%;
  background: #e8f2fe;
  border-radius: 0px 0px 0px 0px;
  box-shadow: 0px 4px 4px 0px rgba(204, 227, 255, 0.64);

  .nav-bd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    width: 1200px;
    height: 50px;

    .title {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      width: 50%;
    }

    ul {
      display: flex;
      align-items: center;

      li {
        padding: 0 25px;
        height: 24px;
        line-height: 24px;
        list-style: none;
        border-right: 1px solid #666666;

        a {
          font-weight: 400;
          color: #333333;
          text-decoration: none;
        }
      }

      .login {
        color: #0074ff !important;
        font-weight: bold !important;
      }
    }

    ul > li:nth-child(4) {
      border: none;
    }
  }

  .nav-na {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    width: 1200px;
    height: 126px;

    .titlenavt {
      text-align: center;

      .img {
        width: 126px;
        height: 66px;
      }

      .name_c {
        font-weight: bold;
        color: #333333;
        margin-top: 10px;
      }
    }

    .search {
      display: flex;
      align-items: center;
      width: 680px;
      height: 52px;
      background: #ffffff;
      border-radius: 6px 6px 6px 6px;
      cursor: pointer;

      .simg {
        width: 22px;
        height: 22px;
        margin: 15px 12px;
      }

      input {
        padding-left: 18px;
        font-size: 16px;
        flex: 1;
        height: auto;
        border: none;
        outline: none;
      }

      .button_s {
        width: 98px;
        height: 52px;
        background: #0074ff;
        border-radius: 0px 6px 6px 0px;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        line-height: 52px;
      }
    }

    .coar {
      .cimg {
        width: 66px;
        height: 66px;
      }

      .txt {
        p {
          font-size: 12px;
          color: #333333;
          margin: 0;
          padding: 0;
        }
      }
    }

    .tell {
      text-align: left;
      cursor: pointer;

      .phone {
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        margin: 5px 0;
      }

      p {
        font-size: 12px;
        color: #333333;
        margin: 0;
        padding: 0;
      }
    }
  }

  .head_n {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    width: 1200px;
    height: 62px;

    .address {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      width: 105px;
      height: 42px;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      text-align: center;
      cursor: pointer;

      .addicon {
        width: 15px;
        height: 18px;
      }

      .city_name {
        font-weight: 500;
        font-size: 16px;
        color: #333333;
      }

      .xbimg {
        width: 14px;
        height: 9px;
      }
    }

    .nav_a {
      display: flex;
      align-items: center;
      flex: 1;
      justify-content: space-evenly;

      li {
        list-style: none;

        a {
          font-weight: 400;
          color: #333333;
          text-decoration: none;
        }
      }

      .cur {
        list-style: none;

        a {
          font-weight: bold;
          font-size: 16px;
          color: #0074ff;
          text-decoration: none;
        }
      }
    }
  }

  .headimg {
    width: 100%;
    height: 100px;

    .imgs {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
